let openModalCount = 0;
let previousPageState = null;

export const lockPageScroll = () => {
  if (typeof document === 'undefined' || typeof window === 'undefined') return;

  if (openModalCount === 0) {
    const { body, documentElement } = document;
    const scrollX = window.pageXOffset || window.scrollX || 0;
    const scrollY = window.pageYOffset || window.scrollY || 0;
    const scrollbarWidth = window.innerWidth - documentElement.clientWidth;

    previousPageState = {
      scrollX,
      scrollY,
      bodyOverflow: body.style.overflow,
      bodyPaddingRight: body.style.paddingRight,
    };

    if (scrollbarWidth > 0) {
      const currentPaddingRight = parseFloat(
        window.getComputedStyle(body).paddingRight
      ) || 0;
      body.style.paddingRight = `${currentPaddingRight + scrollbarWidth}px`;
    }

    body.style.overflow = 'hidden';
    body.classList.add('has-cp-modal');
  }

  openModalCount += 1;
};

export const unlockPageScroll = () => {
  if (typeof document === 'undefined' || typeof window === 'undefined') return;

  openModalCount = Math.max(openModalCount - 1, 0);

  if (openModalCount !== 0 || !previousPageState) return;

  const { body } = document;
  const { scrollX, scrollY } = previousPageState;

  body.style.overflow = previousPageState.bodyOverflow;
  body.style.paddingRight = previousPageState.bodyPaddingRight;
  body.classList.remove('has-cp-modal');
  previousPageState = null;

  window.scrollTo(scrollX, scrollY);
};
